// extracted by mini-css-extract-plugin
export default {"root":"EditorSideMenu_root__E4-Cm","section":"EditorSideMenu_section__+7n4Z","subsectionRoot":"EditorSideMenu_subsectionRoot__LCXkC"};